module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/meal_preference/chefs_choice--xxs@1x-fa0a590ef8482332f7480ecab116771d.png";